/**
 * PitchSection — wrapper that provides scroll-snap alignment and entrance animation.
 * Each section occupies exactly one viewport height and snaps into place.
 */
import { motion } from "framer-motion";
import { usePitchSettings } from "../../contexts/PitchSettingsContext";

export default function PitchSection({ id, children, className = "", dark = false }) {
  const { settings } = usePitchSettings();
  const s = settings.sections?.[id] || {};

  // Allow per-section overrides for padding and max-width
  const paddingX = s.paddingX ?? "px-4 sm:px-8";
  const maxW = s.maxWidth ?? "max-w-6xl";

  return (
    <section
      id={id}
      className={`relative min-h-full w-full flex flex-col justify-center ${paddingX} snap-start snap-always overflow-x-hidden ${
        dark ? "bg-[#070B14]" : "bg-[#0A0F1A]"
      } ${className}`}
      style={{
        fontSize: s.fontSize ? `${s.fontSize}px` : undefined,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className={`relative z-10 ${maxW} w-full min-w-0 mx-auto py-8 sm:py-10 md:py-12`}
      >
        {children}
      </motion.div>
    </section>
  );
}
